import { createContext, useContext } from 'react';

/**
 * PTV2-1157 — which record the surrounding cards are editing.
 *
 * `null` (the default) means "nothing will tear these cards down underneath the user" — the
 * patient-record page. The pedigree node editor provides the selected person's guid, so its unsaved
 * drafts can be flushed when the selection moves to another node or clears.
 *
 * See {@link file://./dirtyRegistry.ts} for how the drafts are tracked and committed.
 */
export const DirtyScopeContext = createContext<string | null>(null);

export function useDirtyScope(): string | null {
  return useContext(DirtyScopeContext);
}
